import { render } from "./SuccessAlert.vue?vue&type=template&id=18f0a9da"
import script from "./SuccessAlert.vue?vue&type=script&lang=js"
export * from "./SuccessAlert.vue?vue&type=script&lang=js"
script.render = render

export default script